<template>
  <div class="watt-meter">
    <div class="watt-meter-top">
      <el-button class="btn btn-left btn-all" @click="addMeterClick(1)" :disabled="newPrivilege==1" :class="[newPrivilege==1?'active':'']">新建电表 +</el-button>
      <div style="clear:both;"></div>
    </div>
    <div class="watt-meter-table">
      <el-table
        :header-cell-style="{background:'#f3f3f3',color:'#323232',height:'50px'}"
        :data="yemiandata"
        border
        style="width: 100%">
        <el-table-column
          prop="station_id"
          label="场站编号"
          width="">
        </el-table-column>
        <el-table-column
          prop="station_name"
          label="场站名称"
          width="">
        </el-table-column>
        <el-table-column
          prop="meter_id"
          label="电表编号">
        </el-table-column>
        <el-table-column
          prop="serial_no"
          label="序列号"
          width="">
          <template slot-scope="scope">{{ scope.row.serial_no | defaultValFilter }}</template>
        </el-table-column>
        <el-table-column
          prop="coefficient"
          label="互感倍数"
          width="">
        </el-table-column>
        <el-table-column
          prop="created_time"
          label="创建时间">
        </el-table-column>
        <el-table-column
          label="操作"
          width="">
          <template slot-scope="scope">
              <el-button class="btn edit" @click="editMeter(scope.row,2)" :disabled="editPrivilege==1" :class="[editPrivilege==1?'active':'']">编辑</el-button>
              <el-button class="btn delete" @click="deleteMeter(scope.row)" :disabled="deletePrivilege==1" :class="[deletePrivilege==1?'active':'']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
        <el-pagination
        background
        layout="prev, pager, next"
        @size-change="handleSizeChange" 
        @current-change="currentChange"
        :total="totalNum">
        </el-pagination>
    </div>
    <!-- 新建 -->
    <el-dialog
		:visible.sync="addMeterDialog"
    customClass="meter-dialog"
		width="934px"
    @close="meterCancelClick"
    :close-on-click-modal="false"
		>
      <p class="title">{{meterTitle}}</p>
      <div class="line"></div>
      <div class="meter-box">
        <div class="meter-row">
          <div class="meter-l"><span class="star">*</span>场站：</div>
          <div class="meter-r">
            <el-select v-model="meterProvince" clearable :disabled="dialogNum==2" placeholder="请选择省" @change="meterProviceChange">
              <el-option
                v-for="item in meterProvinceList"
                :key="item.province"
                :label="item.province"
                :value="item.province">
              </el-option>
            </el-select>
            <el-select v-model="meterCity" clearable :disabled="dialogNum==2" placeholder="请选择市" @change="meterCityChange">
              <el-option
                v-for="item in meterCityList"
                :key="item.city"
                :label="item.city"
                :value="item.city">
              </el-option>
            </el-select>
            <el-select v-model="station_id" clearable :disabled="dialogNum==2" placeholder="请选择场站" @change="meterStationChange">
              <el-option
                v-for="item in meterStationList"
                :key="item.station_id"
                :label="item.station_name"
                :value="item.station_id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="meter-row">
          <div class="meter-l"><span class="star">*</span>编号：</div>
          <div class="meter-r">
            <el-input v-model="meter_id" clearable placeholder="请输入电表编号，唯一"></el-input>
          </div>
        </div>
        <div class="meter-row">
          <div class="meter-l"><span class="star">*</span>互感倍数：</div>
          <div class="meter-r">
            <el-input v-model="coefficient" clearable placeholder="请输入互感倍数"></el-input>
          </div>
        </div>
        <div class="meter-row">
          <div class="meter-l">系列号：</div>
          <div class="meter-r">
            <el-input v-model="serial_no" clearable placeholder="请输入系列号"></el-input>
          </div>
        </div>
        <div class="meter-button">
          <el-button class="meter-cancel" @click="meterCancelClick()">取消</el-button>
          <el-button class="meter-confirm" @click="meterConfirmClick()">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props:["provincesName","cityName","stationId"],
  data () {
    return {
      addMeterDialog:false,
      meterTitle:"",
      tableData: [],
      // 页面需要展现的数据
      yemiandata:[],
      // 页面展现条数
      datanum:10,
      // 开始页数
      startnum:0,
      // 结束页数
      endnum:1,
      // 一共多少页
      totalNum:0,
      meterProvince:"",
      meterProvinceList:[],
      meterCity:"",
      meterCityList:[],
      station_id:"",
      meterStationList:[],
      meter_id:"",
      serial_no:"",
      coefficient:"",
      dialogNum:0,
      meterId:"",
      newPrivilege:1,//新建
      editPrivilege:1,//编辑
      deletePrivilege:1,//删除
    }
  },
  mounted(){
    this.$nextTick(function() {

      let role = [];
      role = this.$store.state.role;
      for(let i in role){
        if(role[i].view_name == "场站管理"){
          for(let j in role[i].chlid){
            if(role[i].chlid[j].view_name == "设备管理"){
              for(let m in role[i].chlid[j].method){
                if(role[i].chlid[j].method[m].method_name == "新建电表"){
                  this.newPrivilege = 0;
                } else if(role[i].chlid[j].method[m].method_name == "编辑电表"){
                  this.editPrivilege = 0;
                } else if(role[i].chlid[j].method[m].method_name == "删除电表"){
                  this.deletePrivilege = 0;
                }
              }
            }
          }
        }
      }
      
      this.getMeterList(this.provincesName,this.cityName,this.stationId);
    });
  },
  watch:{
    "stationId":function(newVal,oldVal){
      this.totalNum = 0;
      this.startnum = 0;
      this.endnum = 1;
      this.getMeterList(this.provincesName,this.cityName,this.stationId);
    },
  },
  methods:{
    handleSizeChange(data){
      // debugger
    },
    currentChange(data){
      this.endnum = data;
      this.startnum = data-1;
      this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
    },
    getMeterList(provincesName,cityName,stationId){
      if(provincesName==undefined){
          provincesName = "";
      }
      if(cityName==undefined){
          cityName = "";
      }
      if(stationId==undefined){
          stationId = "";
      }

      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          action:"getMeterList",
          province:provincesName,
          city:cityName,
          station_id:stationId,
      };
      this.$api({
          method: "post",
          url: "/api.php/DeviceManage/index",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.tableData = su.data.list;
                  this.totalNum = this.tableData.length;
                  if(this.totalNum > 10){
                    this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
                  } else {
                    this.yemiandata=this.tableData;
                  }
                  
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    addMeterClick(num){
      this.addMeterDialog = true;
      this.meterTitle = "新建电表";
      this.getProvinces();
      this.dialogNum = num;
    },
    getProvinces(){
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
      };
      this.$api({
          method: "post",
          url: "/api.php/Currency/get_provinces",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.meterProvinceList = su.data.list;
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    meterProviceChange(province){
      this.meterCity = "";
      this.meterCityList = [];
      this.station_id = "";
      this.meterStationList = [];
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          province:province,
      };
      this.$api({
          method: "post",
          url: "/api.php/Currency/get_citys",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.meterCityList = su.data.list;
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    meterCityChange(city){
      this.station_id = "";
      this.meterStationList = [];
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          city:city,
      };
      this.$api({
          method: "post",
          url: "/api.php/Currency/get_stations",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.meterStationList = su.data.list;
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    meterStationChange(id){
      this.station_id = id;
    },
    meterCancelClick(){
      this.addMeterDialog = false;
      this.meterProvince = "";
      this.meterCity = "";
      this.meterCityList = [];
      this.station_id = "";
      this.meterStationList = [];
      this.meter_id = "";
      this.serial_no = "";
      this.coefficient = "";
      this.meterId = "";
    },
    meterConfirm(){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"addMeter",
        station_id:this.station_id,
        meter_id:this.meter_id,
        serial_no:this.serial_no,
        coefficient:this.coefficient,
      };
      this.$api({
          method: "post",
          url: "/api.php/DeviceManage/index",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.$message.success(su.data.message);
                  this.addMeterDialog = false;
                  this.meterProvince = "";
                  this.meterCity = "";
                  this.meterCityList = [];
                  this.station_id = "";
                  this.meterStationList = [];
                  this.meter_id = "";
                  this.serial_no = "";
                  this.coefficient = "";
                  this.totalNum = 0;
                  this.startnum = 0;
                  this.endnum = 1;
                  this.getMeterList();
                  this.$emit('listenToChildEvent', '空');
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    editMeter(row,num){
      this.dialogNum = num;
      this.meterId = row.id;

      this.meterProvince = row.province;
      this.meterCity = row.city;
      this.station_id = row.station_name;
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"getMeterDetail",
        id:this.meterId,
      };
      this.$api({
          method: "post",
          url: "/api.php/DeviceManage/index",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.addMeterDialog = true;
                  this.meterTitle = "编辑电表";
                  this.meter_id = su.data.list.meter_id;
                  this.serial_no = su.data.list.serial_no;
                  this.coefficient = su.data.list.coefficient;
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    meterEditConfirm(){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"editMeter",
        id:this.meterId,
        meter_id:this.meter_id,
        serial_no:this.serial_no,
        coefficient:this.coefficient,
      };
      this.$api({
          method: "post",
          url: "/api.php/DeviceManage/index",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.$message.success(su.data.message);
                  this.addMeterDialog = false;
                  this.getMeterList(this.provincesName,this.cityName,this.stationId);
                  this.this.meterId = "";
                  this.meter_id = "";
                  this.serial_no = "";
                  this.coefficient = "";
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    meterConfirmClick(){
      if(this.dialogNum == 1){
        this.meterConfirm();
      } else if(this.dialogNum == 2){
        this.meterEditConfirm();
      }
    },
    deleteMeter(row){
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          action:"deleteMeter",
          id:row.id,
      };
      this.$confirm("确定删除", "删除", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: ""
      })
        .then(() => {
          this.$api({
            method: "post",
            url: "/api.php/DeviceManage/index",
            data: params,
            transformRequest: [
              data => {
                let ret = "";
                for (let it in data) {
                  ret +=
                    encodeURIComponent(it) +
                    "=" +
                    encodeURIComponent(data[it]) +
                    "&";
                }
                return ret;
              }
            ]
          })
            .then(su => {
              if (su.data.code == 1) {
                this.$message.success(su.data.message);
                this.getMeterList(this.provincesName,this.cityName,this.stationId);
              } else if (su.data.code == 300)  {
                localStorage.clear(); 
                this.$router.push("/login");
                this.$message.error(su.data.message);
              } else if (su.data.code == 900)  {
              } else  {
                this.$message.error(su.data.message);
              }
            })
            .catch(err => {});
        })
        .catch(() => {});
    },
  },
}
</script>

<style scoped lang="scss">
.watt-meter {
  .watt-meter-top {
    .btn {
      border:none;
      color:#ffffff;
    }
    .btn-left {
      float: left;
    }
    .btn-all {
      margin-left: 1%;
      background-color: #0177BD;
    }
    .btn-all.active {
      background-color: #a5a5a5;
    }
  }
  .watt-meter-table {
    margin-top: 24px;
    width: 98%;
    margin-left: 1%;
    .btn {
      width: 54px;
      height: 26px;
      color:#ffffff;
      border:none;
      padding:0;
      text-align: center;
      font-size: 12px;
    }
    .edit {
      background-color: #0171BB;
    }
    .edit.active {
      background-color: #a5a5a5;
    }
    .delete {
      background-color: #00B270;
    }
    .delete.active {
      background-color: #a5a5a5;
    }
    .rate {
      background-color: #F15500;
    }
    .disabled {
      background-color: #01A2B4;
    }
    .el-button+.el-button {
      margin-left: 5px;
    }
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    margin-right: 18px;
  }
  .meter-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top:16px;
      color: #0171BD;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #EAEAEA;
      margin-bottom: 30px;
    }
    .meter-box {
      .meter-row {
        width: 90%;
        margin-bottom: 16px;
        .meter-l {
          width: 20%;
          display: inline-block;
          text-align: right;
          .star {
            color: #EE0000;
            margin-right: 4px;
          }
        }
        .meter-r {
          width: 75%;
          display: inline-block;
          .el-select {
            width: 32.5%;
          }
          .el-input {
            width: 99%;
          }
        }
      }
    }
    .meter-button {
      margin-top: 40px;
      .meter-cancel {
        width: 30%;
        background-color: #0071BD;
        color:#ffffff;
        border:none;
        height: 50px;
      }
      .meter-confirm {
        width: 30%;
        background-color: #02B36F;
        color:#ffffff;
        border:none;
        height: 50px;
      }
    }
  }
}
</style>
<style lang="scss">
.watt-meter .el-table--enable-row-hover .el-table__body tr:hover>td .edit {
  background-color: #409EFF;
}
</style>


// WEBPACK FOOTER //
// src/components/stationManagement/wattHourMeter.vue